/**
 * Runtime-konfiguration.
 *
 * Värden som skiljer sig mellan körmiljöer läses från `/config.js`, som laddas
 * av index.html innan JS-bundlen körs. Det gör att samma image kan köras mot
 * olika backend-värdar — lokalt på macOS respektive utvecklings-VM:en i Proxmox
 * — utan att byggas om.
 *
 * Filen som levereras i imagen är `public/config.js` (lokala standardvärden).
 * I docker-compose monteras `docker-compose/app-config.js` över den, och
 * `sync-to-vm.sh` installerar `app-config.vm.js` som `app-config.js` på VM:en.
 *
 * Påverkar bara den lokala backend-uppsättningen (REACT_APP_USE_LOCAL_BE=true).
 * Deployade miljöer använder sina fasta hostnamn som förut.
 */

type RuntimeConfig = {
  /** Protokoll + värd till lokal backend, utan avslutande snedstreck. */
  localBackendHost?: string;
};

declare global {
  interface Window {
    __DIREMO_RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

/** Används när varken env-variabel eller config.js finns, t.ex. i tester. */
const DEFAULT_LOCAL_BE_HOST = 'http://192.168.100.100';

const runtimeConfig: RuntimeConfig =
  (typeof window !== 'undefined' && window.__DIREMO_RUNTIME_CONFIG__) || {};

/**
 * Ordningen spelar roll.
 *
 * REACT_APP_LOCAL_BE_HOST bakas in vid bygget och går före config.js. Det är
 * nödvändigt för `npm run start-vm-be`: dev-servern serverar `public/config.js`,
 * som annars skulle peka tillbaka på den lokala dockermiljön.
 *
 * OBS: variabeln får INTE sättas när imagen byggs i pipelinen. Gör man det
 * fryses värdet i bundlen och den inmonterade config.js får ingen effekt, vilket
 * tar bort hela poängen med runtime-konfigurationen.
 */
export const LOCAL_BE_HOST =
  process.env.REACT_APP_LOCAL_BE_HOST || runtimeConfig.localBackendHost || DEFAULT_LOCAL_BE_HOST;
